import { render, staticRenderFns } from "./selectSkuByGoodsID.vue?vue&type=template&id=397581fc&"
import script from "./selectSkuByGoodsID.vue?vue&type=script&lang=js&"
export * from "./selectSkuByGoodsID.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports